// extracted by mini-css-extract-plugin
export default {"Heartbeat":"Heartbeat_Heartbeat__m4PWK"};